import { addDays, addMonths, addWeeks, addYears } from "date-fns";

export const DOSE_INTERVAL_UNITS = ["day", "week", "month", "year"] as const;
export type DoseIntervalUnit = (typeof DOSE_INTERVAL_UNITS)[number];

export const DOSE_INTERVAL_VALUE_OPTIONS = Array.from({ length: 30 }, (_, index) => index + 1);

export type DoseIntervalLike = {
  dose_interval_value?: number | null;
  dose_interval_unit?: DoseIntervalUnit | null;
};

export const isDoseIntervalUnit = (value: string | null | undefined): value is DoseIntervalUnit =>
  Boolean(value && DOSE_INTERVAL_UNITS.includes(value as DoseIntervalUnit));

export const hasDoseInterval = (interval: DoseIntervalLike | null | undefined): boolean =>
  Boolean(
    interval &&
      typeof interval.dose_interval_value === "number" &&
      interval.dose_interval_value > 0 &&
      isDoseIntervalUnit(interval.dose_interval_unit),
  );

export const calculateDoseIntervalDate = (
  baseDate: Date,
  interval: DoseIntervalLike | null | undefined,
): Date | null => {
  if (!hasDoseInterval(interval) || Number.isNaN(baseDate.getTime())) {
    return null;
  }

  switch (interval.dose_interval_unit) {
    case "day":
      return addDays(baseDate, interval.dose_interval_value);
    case "week":
      return addWeeks(baseDate, interval.dose_interval_value);
    case "month":
      return addMonths(baseDate, interval.dose_interval_value);
    case "year":
      return addYears(baseDate, interval.dose_interval_value);
    default:
      return null;
  }
};
